import React, { Component } from 'react';
import { connect } from 'react-redux';
import { isInvalid, hasSubmitFailed } from 'redux-form';
import { push } from 'connected-react-router';
import { createSelector } from 'reselect';
import { bool, any, string } from 'prop-types';

import { ROUTES } from 'constants/routes';

import { actionCreators as customProceduresActions } from '../../../../../redux/customProceduresHandlers';
import { TERMINATION_REQUEST_PROCEDURE } from '../AccountHolderChange/constants';
import { PAYMENT_FORM } from '../../../../../constants/reduxForms';
import WithoutAccounts from '../../../../components/WithoutAccounts';
import { gaTrackPageView } from '../../../../../services/AnalyticsService';

import TerminationRequest from './layout';

class TerminationRequestContainer extends Component {
  componentDidMount() {
    this.props.dispatch(customProceduresActions.getTotalAccounts());
    gaTrackPageView(ROUTES.NEW_TERMINATION_REQUEST);
  }

  componentWillUnmount() {
    this.props.dispatch(customProceduresActions.cleanAccountData());
  }

  handleSubmitFirstStep = response => {
    this.props.dispatch(customProceduresActions.evaluateTerminationRequest(response.clientNumber));
  };

  handleOnCancelRequest = () => {
    this.props.dispatch(customProceduresActions.cleanAccountData());
    this.props.dispatch(push(ROUTES.ACCOUNT_STATUS));
  };

  handleOnSubmitRequest = () => {
    const currentAccount = this.props.totalAccounts.find(
      account => account.clientNumber === this.props.tempClientNumber
    );
    this.props.dispatch(
      customProceduresActions.createTerminateRequest({
        clientNumber: this.props.tempClientNumber,
        address: currentAccount && currentAccount.address,
        type: TERMINATION_REQUEST_PROCEDURE
      })
    );
  };

  render() {
    return (
      <TerminationRequest
        loading={this.props.loading}
        accountsData={this.props.totalAccounts}
        handleSubmitFirsStep={this.handleSubmitFirstStep}
        currentStep={this.props.currentStep}
        onCancelRequest={this.handleOnCancelRequest}
        onSubmitRequest={this.handleOnSubmitRequest}
        tempClientNumber={this.props.tempClientNumber}
        customProcedureData={this.props.customProcedureData}
        billList={this.props.billList}
        invalid={this.props.invalid}
        submitFailed={this.props.submitFailed}
        accountTotalDebt={this.props.accountTotalDebt}
        accountDueDebt={this.props.accountDueDebt}
      />
    );
  }
}

const accountsSelector = createSelector(
  store => store.customProcedures.totalAccounts,
  totalAccounts =>
    totalAccounts &&
    totalAccounts.map(account => ({
      clientNumber: account.client_number,
      address: account.address,
      supplyId: account.client_number,
      cancel_service_enabled: account.cancel_service_enabled
    }))
);

TerminationRequestContainer.propTypes = {
  loading: bool,
  totalAccounts: any, // eslint-disable-line
  currentStep: string,
  tempClientNumber: string,
  billList: any, // eslint-disable-line
  customProcedureData: any, // eslint-disable-line
  invalid: bool,
  submitFailed: bool,
  accountTotalDebt: any, // eslint-disable-line
  accountDueDebt: any // eslint-disable-line
};

const mapStateToProps = store => ({
  loading: store.customProcedures.loading || store.customProcedures.totalAccountsLoading,
  currentStep: store.customProcedures.currentStep,
  customProcedureData: store.customProcedures.customProcedureData,
  tempClientNumber: store.customProcedures.tempClientNumber,
  totalAccounts: accountsSelector(store),
  billList: store.customProcedures.accountTotalDebt,
  invalid: isInvalid(PAYMENT_FORM)(store),
  submitFailed: hasSubmitFailed(PAYMENT_FORM)(store),
  accountTotalDebt: store.customProcedures.accountTotalDebt,
  accountDueDebt: store.customProcedures.accountDueDebt,
  accounts: store.account.accounts,
  accountsLoading: store.account.accountsLoading,
  accountsError: store.account.accountsError
});

export default connect(mapStateToProps)(
  WithoutAccounts({
    shouldShowMessage: props => props.accounts.length === 0 && !props.accountsLoading,
    accountsError: props => props.accountsError
  })(TerminationRequestContainer)
);
